import * as React from "react";
import { View } from "react-native";
import Svg, { Circle } from "react-native-svg";

function Dot(props) {
  return (
    <View style={{ marginHorizontal: 4 }}>
      <Svg
        width={props.radius ?? "5"}
        height={props.radius ?? "5"}
        viewBox="0 0 5 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          fill={props.fill ?? "rgba(0, 0, 0, 0.2)"}
          // fill-opacity="0.02"
        />
      </Svg>
    </View>
  );
}

export default Dot;
